"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var createSteps_1 = require("./createSteps");
var stepsReducer_1 = require("./stepsReducer");
exports.StepsContext = React.createContext({
    steps: {},
    goToStep: function (stepKey) {
        return;
    },
    completeStep: function (stepKey) {
        return;
    },
    dispatch: function (action) {
        /* this function gets overwritten when context is setup */
        return;
    } // tslint:disable-line
});
/** Generic Type defaults to IStep */
/** @component */
function StepsConsumer(props) {
    var stepCount = props.stepCount, initialStep = props.initialStep, onStepChange = props.onStepChange, children = props.children, initialValue = props.initialValue;
    var startNumber = initialStep || 1;
    var initialState = initialValue || createSteps_1.createSteps(stepCount, startNumber, undefined);
    var _a = React.useReducer(stepsReducer_1.stepsReducer, initialState), state = _a[0], dispatch = _a[1];
    var goToStep = function (stepKey) {
        if (Object.keys(state).indexOf(stepKey) === -1) {
            return;
        }
        dispatch({
            type: 'GO_TO_STEP',
            value: stepKey
        });
    };
    var completeStep = function (stepKey) {
        if (Object.keys(state).indexOf(stepKey) === -1) {
            return;
        }
        dispatch({
            type: 'COMPLETE_STEP',
            value: stepKey
        });
    };
    React.useEffect(function () {
        if (onStepChange) {
            var currentStepKey = Object.keys(state).find(function (step) { return state[step].isEdit === true; }) || "step" + startNumber;
            var allStepsComplete = Object.keys(state).every(function (step) { return state[step].isComplete === true; });
            onStepChange({
                currentStepKey: currentStepKey,
                allStepsComplete: allStepsComplete,
                stepState: state
            });
        }
    }, [state, onStepChange, startNumber]);
    return (React.createElement(exports.StepsContext.Provider, { value: { steps: state, dispatch: dispatch, goToStep: goToStep, completeStep: completeStep } },
        React.createElement(exports.StepsContext.Consumer, null, children)));
}
exports.StepsConsumer = StepsConsumer;
//# sourceMappingURL=StepsContext.js.map